import React, { useState } from 'react';
import { Job, JobBriefing as JobBriefingType } from '../types';
import { Icons } from '../constants';

interface Props {
  job: Job;
  onComplete: (briefing: Omit<JobBriefingType, 'id' | 'createdAt'>) => void;
  onClose: () => void;
}

const JobBriefing: React.FC<Props> = ({ job, onComplete, onClose }) => {
  const [scope, setScope] = useState(job.lineItems.map(li => li.description).join(', '));
  const [crew, setCrew] = useState('');
  const [signedBy, setSignedBy] = useState('');

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    onComplete({
      jobId: job.id,
      clientName: job.clientName,
      address: job.address,
      scopeOfWork: scope,
      crewMembers: crew.split(',').map(s => s.trim()).filter(Boolean),
      date: new Date().toISOString(),
      signedOffBy: signedBy
    });
  };

  return (
    <div className="fixed inset-0 bg-bark/60 backdrop-blur-sm flex items-center justify-center z-[120] p-4">
      <div className="bg-white rounded-3xl w-full max-w-2xl overflow-hidden shadow-2xl">
        <div className="bg-palm p-6 text-white flex justify-between items-center">
          <div className="flex items-center space-x-3">
            <Icons.Document className="w-6 h-6" />
            <h2 className="text-xl font-black uppercase tracking-widest">Job Briefing</h2>
          </div>
          <button onClick={onClose} className="text-white/70 hover:text-white transition">
            <Icons.Close className="w-6 h-6" />
          </button>
        </div>
        
        <form onSubmit={handleSubmit} className="p-8 space-y-6">
          <div className="grid grid-cols-2 gap-6">
            <div>
              <label className="block text-xs font-bold text-stone-500 uppercase tracking-widest mb-1">Client</label>
              <p className="font-bold text-bark">{job.clientName}</p>
            </div>
            <div>
              <label className="block text-xs font-bold text-stone-500 uppercase tracking-widest mb-1">Location</label>
              <p className="font-bold text-bark">{job.address}</p>
            </div>
          </div>

          <div>
            <label className="block text-xs font-bold text-stone-500 uppercase tracking-widest mb-1">Scope of Work</label>
            <textarea 
              required
              rows={3}
              className="w-full p-4 bg-stone-50 rounded-xl border-none focus:ring-2 focus:ring-gecko font-medium text-bark"
              value={scope}
              onChange={e => setScope(e.target.value)}
            />
          </div>

          <div>
            <label className="block text-xs font-bold text-stone-500 uppercase tracking-widest mb-1">Crew Members (Comma separated)</label>
            <input 
              required
              type="text"
              placeholder="e.g. John Doe, Jane Smith"
              className="w-full p-4 bg-stone-50 rounded-xl border-none focus:ring-2 focus:ring-gecko font-medium text-bark"
              value={crew}
              onChange={e => setCrew(e.target.value)}
            />
          </div>

          <div>
            <label className="block text-xs font-bold text-stone-500 uppercase tracking-widest mb-1">Signed Off By (Foreman)</label>
            <input 
              required
              type="text"
              placeholder="Your Name"
              className="w-full p-4 bg-stone-50 rounded-xl border-none focus:ring-2 focus:ring-gecko font-medium text-bark"
              value={signedBy}
              onChange={e => setSignedBy(e.target.value)}
            />
          </div>

          <div className="pt-4">
            <button type="submit" className="w-full py-4 bg-palm text-white rounded-xl font-black uppercase tracking-widest hover:bg-gecko transition shadow-lg shadow-palm/20">
              Complete Briefing & Sign Off
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default JobBriefing;
